export default function GetVoucherData(_domain){
  if(_domain==="https://api.e-paylink.com" || _domain==="https://api.westernunion.gr"){
    let finres1 = "haz8sdjkdas561"; finres1 = finres1.substring(2, 2+2);
    let finres2 = "haz8ejjsdjkdas"; finres2 = finres2.substring(4, 4+3);
    let finres3 = "4hp8h4$YHH345d"; finres3 = finres3.substring(2, 2+2);
    return btoa(finres1+finres2+finres3);
  }
  else{
    return "cGFub3M5OQ==";
  }
}
